export default __webpack_public_path__ + "static/media/profile_picture.c2b3210c.jpg";